export const profileTranslations = {
  avatar: {
    key: 'profile.avatar',
    defaultValue: 'Avatar',
  },
  name: {
    key: 'profile.name',
    defaultValue: 'Name',
  },
  fullName: {
    key: 'profile.fullName',
    defaultValue: '{{firstName}} {{lastName}}',
  },
  upn: {
    key: 'profile.email',
    defaultValue: 'Email',
  },
  addEmail: {
    key: 'profile.addEmail',
    defaultValue: 'Add email',
  },
  details: {
    key: 'profile.details',
    defaultValue: 'Details',
  },
  staffId: {
    key: 'profile.staffId',
    defaultValue: 'Staff ID',
  },
  role: {
    key: 'profile.role',
    defaultValue: 'Role',
  },
  requested: {
    key: 'profile.requested',
    defaultValue: 'Requested',
  },
};

export const userPreferences = {
  title: {
    key: 'userPreferences.title',
    defaultValue: 'Preferences',
  },
  subtitle: {
    key: 'userPreferences.subtitle',
    defaultValue:
      'Customize your experience by choosing your preferred language, currency, widget category, and light or dark mode theme.',
  },
  chooseLanguage: {
    key: 'userPreferences.chooseLanguage',
    defaultValue: 'Choose Language:',
  },
  chooseCurrency: {
    key: 'userPreferences.chooseCurrency',
    defaultValue: 'Choose Currency:',
  },
  chooseCategory: {
    key: 'userPreferences.chooseCategory',
    defaultValue: 'Choose Category:',
  },
  chooseStartPage: {
    key: 'userPreferences.chooseStartPage',
    defaultValue: 'Choose Store Start Page:',
  },
  chooseMode: {
    key: 'userPreferences.chooseMode',
    defaultValue: 'Choose Mode:',
  },
  button: {
    key: 'userPreferences.button',
    defaultValue: 'Save Preferences',
  },
  permissionText: {
    key: 'userPreferences.permissionText',
    defaultValue: 'Note: You do not have permission to view this page!',
  },
};

export const accessesRequestedTranslations = {
  title: {
    key: 'accessesRequested.title',
    defaultValue: 'Accesses Requested',
  },
  subtitle: {
    key: 'accessesRequested.subtitle',
    defaultValue:
      'Easily track your pending access requests, see their review status, and know exactly how many days are left for approval.',
  },
  viewRequest: {
    key: 'accessesRequested.viewRequest',
    defaultValue: 'View Request',
  },
  noRequests: {
    key: 'accessesRequested.noRequests',
    defaultValue: 'No pending access requests.',
  },
  error: {
    key: 'accessesRequested.error',
    defaultValue: 'Failed to load requests',
  },
  loading: {
    key: 'accessesRequested.loading',
    defaultValue: 'Loading requests...',
  },
  viewRequestModal: {
    requestedId: {
      key: 'accessesRequested.viewRequestModal.requestedId',
      defaultValue: 'Requested ID',
    },
    organizationId: {
      key: 'accessesRequested.viewRequestModal.organizationId',
      defaultValue: 'Organization ID',
    },
    organizationName: {
      key: 'accessesRequested.viewRequestModal.organizationName',
      defaultValue: 'Organization Name',
    },
  },
  reapply: {
    key: 'accessesRequested.reapply',
    defaultValue: 'Reapply',
  },
  reapplySuccess: {
    key: 'accessesRequested.reapplySuccess',
    defaultValue: 'Successfully reapplied for access request.',
  },
  reapplyError: {
    key: 'accessesRequested.reapplyError',
    defaultValue: 'Failed to reapply for access request.',
  },
};

export const permissionsTranslations = {
  title: {
    key: 'permissions.title',
    defaultValue: 'Permissions',
  },
  pagePermissions: {
    key: 'permissions.pagePermissions',
    defaultValue: 'Page Permissions',
  },
  pagePermissionsDescription: {
    key: 'permissions.pagePermissionsDescription',
    defaultValue:
      'View the page access permissions assigned to your profile across key areas such as Area Overview, Area Results, Widget Settings, and Access Requests. These permissions determine the actions available to you on each page.',
  },
  employeePagePermissionsDescription: {
    key: 'permissions.employeePagePermissionsDescription',
    defaultValue:
      'View the page access permissions assigned to the selected user across key areas such as Area Overview, Area Results, Widget Settings, and Access Requests. These permissions determine the actions available to the user on each page.',
  },
  widgetPermissions: {
    key: 'permissions.widgetPermissions',
    defaultValue: 'Widget Permissions',
  },
  widgetPermissionsDescription: {
    key: 'permissions.widgetPermissionsDescription',
    defaultValue:
      'View the widget permissions assigned to your profile within the platform. These permissions determine which widgets you can access and the actions you can perform based on your role and responsibilities.',
  },
  employeeWidgetPermissionsDescription: {
    key: 'permissions.employeeWidgetPermissionsDescription',
    defaultValue:
      'View the widget permissions assigned to the selected user within the platform. These permissions determine which widgets the user can access and the actions they can perform based on their role and responsibilities.',
  },
  settingsPermissions: {
    key: 'permissions.settingsPermissions',
    defaultValue: 'Settings Permissions',
  },
  settingsPermissionsDescription: {
    key: 'permissions.settingsPermissionsDescription',
    defaultValue:
      'View the settings permissions assigned to your profile for system configurations and administrative features. These permissions determine which settings you can access and manage within the platform.',
  },
  employeeSettingsPermissionsDescription: {
    key: 'permissions.employeeSettingsPermissionsDescription',
    defaultValue:
      'View the settings permissions assigned to the selected user for system configurations and administrative features. These permissions determine which settings the user can access and manage within the platform.',
  },
  viewPermissions: {
    key: 'permissions.viewPermissions',
    defaultValue: 'View Permissions',
  },
  pageColumnLabel: {
    key: 'permissions.pageColumnLabel',
    defaultValue: 'Pages',
  },
  widgetsColumnLabel: {
    key: 'permissions.widgetsColumnLabel',
    defaultValue: 'Widgets',
  },
  overViewWidgetsColumnLabel: {
    key: 'permissions.overViewWidgetsColumnLabel',
    defaultValue: 'Overview Widgets',
  },
  settingsColumnLabel: {
    key: 'permissions.settingsColumnLabel',
    defaultValue: 'Settings',
  },
  updateAccess: {
    key: 'permissions.updateAccess',
    defaultValue: 'Update Access',
  },
  editAccess: {
    key: 'permissions.editAccess',
    defaultValue: 'Edit Access',
  },
};
